
import { computed, defineComponent } from 'vue'

// components
import Cheap from '@/common/components/UI/Cheap/index.vue'

// constants
import { DELIVERY_STATUSES } from '@/core/constants/delivery.constants'

export default defineComponent({
    components: {
        cheap: Cheap,
    },
    props: {
        statusNumber: {
            type: Number,
            default: null,
        },
        status: {
            type: String,
            default: null,
        },
        wasReturned: {
            type: Number,
            default: 0,
        },
        isAddedToAccrual: {
            type: Number,
            defalt: 0,
        },
    },
    setup(props) {
        // const computedText = computed(() => {
        //     if (props.isAddedToAccrual) return 'Добавлено в начисление 1С'
        //     if (props.wasReturned) return DELIVERY_STATUSES[5]
        //     if (!props.statusNumber) return DELIVERY_STATUSES[0]
        //     return DELIVERY_STATUSES[props.statusNumber]
        // })

        const computedClass = computed(() => {
            if (props.isAddedToAccrual) return 'green'
            if (props.wasReturned) return 'red'
            if (!props.statusNumber) return 'yellow'
            if (props.statusNumber === 1) return 'primary'
            else if (props.statusNumber === 3) return 'green'
            else if (props.statusNumber === 4) return 'red'
            return 'yellow'
        })

        return { computedClass }
    },
})
